<p-toast></p-toast>
<div class="container-fluid" *ngIf="invoiceForm; else elseBlock">
    <div class="row">
        <div class="col-md-12">
            <div *ngIf="this.viewType == 'AllFamily' && !hasSiblings">
                <div class="flex mt-1 align-items-center">
                    <img
                        *ngIf="
                            invoiceData.data.invoiceObj[0]?.profileimg !=
                                undefined;
                            else noImageFound
                        "
                        [src]="invoiceData.data.invoiceObj[0].profileimg"
                        width="42"
                        height="42"
                        alt="profile"
                        class="border-circle border-2 border-primary flex-shrink-0"
                    />
                    <ng-template #noImageFound>
                        <div
                            class="circle flex justify-content-center align-items-center mr-1"
                            [style.background-color]="
                                getBackgroundColor(invoices?.id)
                            "
                        >
                            {{ getInitials(invoices?.fullName) }}
                        </div>
                    </ng-template>
                    <div class="ml-2">
                        <div class="text-base font-bold text-900 mb-0">
                            <span class="student-name">{{
                                this.invoices?.fullName
                            }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="this.viewType == 'MultiFamily' && !hasSiblings">
                <div
                    class="flex mt-1 align-items-center"
                    *ngFor="let student of this.invoiceData.data.invoiceObj"
                >
                    <ng-container *ngIf="student.profileimg; else showInitials">
                        <img
                            [src]="student.profileimg"
                            width="42"
                            height="42"
                            alt="profile"
                            class="border-circle border-2 border-primary flex-shrink-0"
                        />
                    </ng-container>
                    <ng-template #showInitials>
                        <div
                            class="circle flex justify-content-center align-items-center mr-1"
                            [style.background-color]="
                                getBackgroundColor(student.id)
                            "
                            style="
                                width: 42px;
                                height: 42px;
                                font-size: 16px;
                                color: #fff;
                                font-weight: bold;
                            "
                        >
                            {{ getInitials(student.fullName) }}
                        </div>
                        <!-- ## end of logic  -->
                    </ng-template>
                    <div class="ml-2">
                        <div class="text-base font-bold text-900 mb-0">
                            <span class="student-name">{{
                                student?.fullName
                            }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex mt-1 align-items-center">
                <div
                    class="text-base font-bold text-900 mb-0"
                    *ngIf="!this.invoiceData.data.isRefund && !hasSiblings"
                >
                    <span class="student-name">
                        Account Balance : $ {{ balanceAmount || 0 | number:'1.2-2' }}</span
                    >
                </div>

                <div
                    class="text-base font-bold text-900 mb-0"
                    *ngIf="!this.invoiceData.data.isRefund && hasSiblings"
                >
                    <span class="student-name">
                        Total Outstanding : $ {{ getTotalSiblingUnpaidAmount() | number:'1.2-2' }}</span
                    >
                </div>

                <div
                    class="text-base font-bold text-900 mb-0"
                    *ngIf="this.invoiceData.data.isRefund && !hasSiblings && !isLoadingRefundData"
                >
                    <span class="student-name">
                        Max. Refund Amount : $ {{ maxRefundAmount || 0  | number:'1.2-2'}}</span
                    >
                </div>

                <!-- Loading refund data -->
                <div
                    class="text-base font-bold text-900 mb-0"
                    *ngIf="this.invoiceData.data.isRefund && isLoadingRefundData"
                >
                    <span class="student-name">
                        <i class="pi pi-spin pi-spinner"></i> Loading refund data...</span
                    >
                </div>

                <!-- Total Max Refund for Siblings -->
                <div
                    class="text-base font-bold text-900 mb-0"
                    *ngIf="this.invoiceData.data.isRefund && hasSiblings"
                >
                    <span class="student-name">
                        Total Max. Refund Amount : $ {{ getTotalMaxRefundAmount() | number:'1.2-2'}}</span
                    >
                </div>
            </div>
            <div class="border-top-2 border-primary-400 my-2"></div>

            <form [formGroup]="receivePmtFrom">
                <div class="p-fluid p-formgrid grid">
                    <!-- ===== REFUND FLOW ===== -->
                    <ng-container *ngIf="this.config.data.isRefund">
                        <!-- Sibling Refund Amounts Section -->
                        <div class="field col-12 p-0 mb-0" *ngIf="hasSiblings">
                            <div class="sibling-refunds-container">
                                <div class="sibling-refund-row" *ngFor="let sibling of siblingRefundData; let i = index">
                                    <div class="sibling-info-refund">
                                        <div class="flex align-items-center">
                                            <ng-container *ngIf="sibling.profileimg; else showInitials">
                                                <img
                                                    [src]="sibling.profileimg"
                                                    width="42"
                                                    height="42"
                                                    alt="profile"
                                                    class="border-circle border-2 border-primary flex-shrink-0"
                                                />
                                            </ng-container>
                                            <ng-template #showInitials>
                                                <div
                                                    class="circle flex justify-content-center align-items-center"
                                                    [style.background-color]="getBackgroundColor(sibling.studentId)"
                                                >
                                                    {{ getInitials(sibling.studentName) }}
                                                </div>
                                            </ng-template>
                                            <div class="ml-2">
                                                <div class="sibling-label-refund">{{ sibling.studentName }} (Amount Paid - ${{ sibling.originalPaidAmount | number:'1.2-2' }})</div>
                                                <div class="sibling-max-refund">Max refundable: ${{ sibling.maxRefundAmount | number:'1.2-2' }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="sibling-input-refund">
                                        <div class="p-inputgroup">
                                            <span class="p-inputgroup-addon">$</span>
                                            <p-inputNumber
                                                [(ngModel)]="sibling.refundAmount"
                                                [ngModelOptions]="{standalone: true}"
                                                [min]="0"
                                                [max]="sibling.maxRefundAmount"
                                                [minFractionDigits]="2"
                                                [maxFractionDigits]="2"
                                                mode="decimal"
                                                [useGrouping]="false"
                                                locale="en-US"
                                                [disabled]="sibling.maxRefundAmount === 0"
                                                placeholder="0.00"
                                                (onInput)="validateSiblingRefundAmount(i, $event)"
                                                (onBlur)="validateSiblingRefundAmount(i, $event)"
                                            ></p-inputNumber>
                                        </div>
                                        <small class="text-danger" *ngIf="sibling.refundAmount > sibling.maxRefundAmount && sibling.maxRefundAmount > 0">
                                            Amount cannot exceed ${{ sibling.maxRefundAmount | number:'1.2-2' }}
                                        </small>
                                        <small class="text-danger" *ngIf="sibling.refundAmount < 0">
                                            Amount cannot be negative
                                        </small>
                                        <small class="text-danger" *ngIf="sibling.maxRefundAmount === 0">
                                            Refund has been processed for {{ sibling.studentName }}. 
                                        </small>
                                    </div>
                                </div>
                                <div class="sibling-total-row-refund">
                                    <span class="total-label">Total Refund:</span>
                                    <span class="total-amount">${{ getTotalRefundAmount() | number:'1.2-2' }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Single Refund Amount and Payment Type in Same Row -->
                        <div class="field col-12 md:col-6 mb-0" *ngIf="!hasSiblings">
                            <label
                                htmlFor="amount"
                                [appAsterisk]="true"
                                class="opacity-50"
                                >Amount</label
                            >
                            <div class="p-inputgroup">
                                <span class="p-inputgroup-addon">$</span>
                                <p-inputNumber
                                    id="amount"
                                    formControlName="amount"
                                    inputId="minmaxfraction"
                                    mode="decimal"
                                    [useGrouping]="false"
                                    [min]="0"
                                    [minFractionDigits]="2"
                                    [maxFractionDigits]="2"
                                    locale="en-US"
                              ></p-inputNumber>
                            </div>
                            <small
                                class="p-error"
                                *ngIf="
                                    receivePmtFrom.get('amount')?.invalid &&
                                    receivePmtFrom.get('amount')?.touched
                                "
                            >
                                <span *ngIf="receivePmtFrom.get('amount')?.errors?.['required']">
                                    Amount is required.
                                </span>
                                <span *ngIf="receivePmtFrom.get('amount')?.errors?.['max']">
                                    Refund amount cannot exceed the maximum refund amount of ${{ maxRefundAmount | number: '1.2-2' }}.
                                </span>
                                <span *ngIf="receivePmtFrom.get('amount')?.errors?.['min']">
                                    Amount must be greater than $0.
                                </span>
                            </small>
                        </div>

                        <!-- Payment Type Field (same row for single refund) -->
                        <div class="field col-12 md:col-6 mb-0" *ngIf="!hasSiblings">
                            <label
                                htmlFor="lastname2"
                                [appAsterisk]="true"
                                class="opacity-50"
                                >Payment Type</label
                            >
                            <p-dropdown
                                formControlName="paymentMode"
                                [options]="paymentModeList"
                                optionValue="value"
                                placeholder="Select payment type"
                                optionLabel="value"
                                appendTo="body"
                            >
                            </p-dropdown>
                            <app-form-field-validation
                                [control]="receivePmtFrom.get('paymentMode')!"
                            ></app-form-field-validation>
                        </div>
                    </ng-container>
                    
                    <!-- Payment Type Field (for refund flow with siblings - full width) -->
                    <div class="field col-12 mb-0" *ngIf="this.config.data.isRefund && hasSiblings">
                        <label
                            htmlFor="lastname2"
                            [appAsterisk]="true"
                            class="opacity-50"
                            >Payment Type</label
                        >
                        <p-dropdown
                            formControlName="paymentMode"
                            [options]="paymentModeList"
                            optionValue="value"
                            placeholder="Select payment type"
                            optionLabel="value"
                            appendTo="body"
                        >
                        </p-dropdown>
                        <app-form-field-validation
                            [control]="receivePmtFrom.get('paymentMode')!"
                        ></app-form-field-validation>
                    </div>

                    <!-- ===== PAYMENT FLOW ===== -->
                    <ng-container *ngIf="!this.config.data.isRefund">
                        <!-- Multi-Family Dropdown -->
                        <div class="field col-12 p-0 m-0">
                            <div
                                class="col-12"
                                *ngIf="multiFamilyDataList?.length > 0"
                            >
                                <label [appAsterisk]="true" class="opacity-50"
                                    >Select Family</label
                                >
                                <p-dropdown
                                    [options]="multiFamilyDataList"
                                    formControlName="selectedFamily"
                                    optionLabel="name"
                                    optionValue="id"
                                    (onChange)="onFamilyChange($event)"
                                    placeholder="Select a Family"
                                >
                                </p-dropdown>
                            </div>
                        </div>

                        <!-- Payment Type Field (moved above Receive Method) -->
                        <div class="field col-12 mb-0">
                            <label
                                htmlFor="lastname2"
                                [appAsterisk]="true"
                                class="opacity-50"
                                >Payment Type</label
                            >
                            <p-dropdown
                                formControlName="paymentMode"
                                [options]="paymentModeList"
                                optionValue="value"
                                placeholder="Select payment type"
                                optionLabel="value"
                                appendTo="body"
                            >
                            </p-dropdown>
                            <app-form-field-validation
                                [control]="receivePmtFrom.get('paymentMode')!"
                            ></app-form-field-validation>
                        </div>

                        <!-- Receive Method Section -->
                        <div class="field col-12 mb-0">
                            <label class="form-label">Receive Method</label>
                            
                            <!-- Current Outstanding Option -->
                            <div class="radio-group mb-2">
                                <p-radioButton
                                    name="receiveMethod"
                                    value="max"
                                    inputId="maxOutstanding"
                                    formControlName="receiveMethod"
                                    (onClick)="onReceiveMethodChange('max')"
                                ></p-radioButton>
                                <label for="maxOutstanding" class="radio-label">
                                    Current Outstanding <span *ngIf="!hasSiblings">(Family Balance)</span>
                                </label>
                            </div>
                            
                            <!-- Show outstanding amount when max is selected -->
                            <div *ngIf="receivePmtFrom.get('receiveMethod')?.value === 'max'" class="mb-2">
                                <div class="p-inputgroup">
                                    <span class="p-inputgroup-addon">$</span>
                                    <input 
                                        pInputText 
                                        formControlName="amount" 
                                        [readonly]="true"
                                        class="custom-input" 
                                        placeholder="Total amount"
                                        style="background-color: #f5f5f5; cursor: not-allowed;"
                                    />
                                </div>
                            </div>

                            <!-- Custom Amount Option -->
                            <div class="radio-group mb-2">
                                <p-radioButton
                                    name="receiveMethod"
                                    value="custom"
                                    inputId="customAmount"
                                    formControlName="receiveMethod"
                                    (onClick)="onReceiveMethodChange('custom')"
                                ></p-radioButton>
                                <label for="customAmount" class="radio-label">Custom Amount</label>
                            </div>

                            <!-- Single custom amount input -->
                            <div *ngIf="receivePmtFrom.get('receiveMethod')?.value === 'custom' && !hasSiblings" class="mb-2">
                                <div class="p-inputgroup">
                                    <span class="p-inputgroup-addon">$</span>
                                    <p-inputNumber
                                        formControlName="amount"
                                        [min]="0.01"
                                        [minFractionDigits]="2"
                                        [maxFractionDigits]="2"
                                        mode="decimal"
                                        [useGrouping]="false"
                                        locale="en-US"
                                        placeholder="Enter custom amount"
                                        class="custom-input"
                                    ></p-inputNumber>
                                </div>
                                <small
                                    class="p-error"
                                    *ngIf="
                                        (receivePmtFrom.get('amount')?.invalid &&
                                        (receivePmtFrom.get('amount')?.touched || receivePmtFrom.get('amount')?.dirty)) ||
                                        (receivePmtFrom.get('amount')?.value !== null && receivePmtFrom.get('amount')?.value <= 0)
                                    "
                                >
                                    <span *ngIf="receivePmtFrom.get('amount')?.errors?.['required'] || receivePmtFrom.get('amount')?.errors?.['min'] || receivePmtFrom.get('amount')?.value === 0">
                                        Amount is required and must be greater than $0.
                                    </span>
                                </small>
                                <div class="helper-text">
                                    Outstanding: ${{ balanceAmount | number:'1.2-2'}}
                                </div>
                            </div>

                            <!-- Multi-sibling custom amounts -->
                            <div *ngIf="receivePmtFrom.get('receiveMethod')?.value === 'custom' && hasSiblings" class="sibling-payments-container mb-2">
                                <div class="sibling-payment-row" *ngFor="let sibling of siblingPaymentData; let i = index">
                                    <div class="sibling-info">
                                        <div class="flex align-items-center">
                                            <ng-container *ngIf="sibling.profileimg; else showInitials3">
                                                <img
                                                    [src]="sibling.profileimg"
                                                    width="42"
                                                    height="42"
                                                    alt="profile"
                                                    class="border-circle border-2 border-primary flex-shrink-0"
                                                />
                                            </ng-container>
                                            <ng-template #showInitials3>
                                                <div
                                                    class="circle flex justify-content-center align-items-center"
                                                    [style.background-color]="getBackgroundColor(sibling.studentId)"
                                                >
                                                    {{ getInitials(sibling.studentName) }}
                                                </div>
                                            </ng-template>
                                            <div class="ml-2">
                                                <div class="sibling-label">{{ sibling.studentName }}</div>
                                                <div class="sibling-outstanding">Outstanding: ${{ sibling.unpaidAmount | number:'1.2-2' }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="sibling-input">
                                        <div class="p-inputgroup">
                                            <span class="p-inputgroup-addon">$</span>
                                            <p-inputNumber
                                                [(ngModel)]="sibling.paymentAmount"
                                                [ngModelOptions]="{standalone: true}"
                                                [min]="0"
                                                [minFractionDigits]="2"
                                                [maxFractionDigits]="2"
                                                mode="decimal"
                                                [useGrouping]="false"
                                                locale="en-US"
                                                placeholder="0.00"
                                                (onInput)="validateSiblingPaymentAmount(i, $event)"
                                                (onBlur)="validateSiblingPaymentAmount(i, $event)"
                                            ></p-inputNumber>
                                        </div>
                                        <small 
                                            class="p-error" 
                                            *ngIf="siblingHasNoInvoices(i)"
                                        >
                                            {{ getSiblingNoInvoicesError(i) }}
                                        </small>
                                        <small class="helper-text" style="color: #6c757d;" *ngIf="!siblingHasNoInvoices(i)">
                                            Outstanding: ${{ sibling.unpaidAmount | number:'1.2-2' }}
                                        </small>
                                    </div>
                                </div>
                                <div class="sibling-total-row" [class.total-error]="!isSiblingPaymentValid()">
                                    <span class="total-label">Total Payment:</span>
                                    <span class="total-amount">${{ getTotalSiblingPaymentAmount() | number:'1.2-2' }}</span>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    
                    <!-- Cheque Number Field -->
                    <div class="field col-12 mb-0" *ngIf="optionalDateControl">
                        <label
                            htmlFor="lastname2"
                            [appAsterisk]="optionalDateControl"
                            class="opacity-50"
                            >Cheque Number</label
                        >
                        <input
                            pInputText
                            id="note"
                            type="text"
                            formControlName="chequeNumber"
                        />
                        <app-form-field-validation
                            [control]="receivePmtFrom.get('chequeNumber')!"
                        ></app-form-field-validation>
                    </div>
                    
                    <!-- Optional Note Field -->
                    <div class="field col-12 mb-0">
                        <span class="p-float-label">
                            <textarea
                                id="description"
                                [rows]="2"
                                class="full-width-textarea"
                                formControlName="description"
                                pInputTextarea
                                appFirstLetterCapital
                            ></textarea>
                            <label for="float-input" class="opacity-50"
                                >Add Optional Note</label
                            >
                        </span>
                        <app-form-field-validation
                            [control]="receivePmtFrom.get('description')!"
                        ></app-form-field-validation>
                    </div>
                    
                    <!-- Email Notification Checkbox (only for payments) -->
                    <div
                        class="col-12 mb-0 py-0"
                        *ngIf="!this.config.data.isRefund"
                    >
                        <input
                            type="checkbox"
                            name="isSendEmail"
                            id="isSendEmail"
                            formControlName="isSendEmail"
                        />
                        &nbsp;
                        <label for="note" class="mb-0"
                            >Send Email Notification To Parents On
                            Payment</label
                        >
                    </div>
                    
                    <!-- Admin Only Note -->
                    <div class="field col-12 mb-0">
                        <label htmlFor="lastname2" class="opacity-50"
                            >Admin Only Note</label
                        >
                        <input
                            pInputText
                            id="note"
                            type="text"
                            formControlName="note"
                            appCapitalizeFirstLetter
                        />
                    </div>
                </div>
                
                <!-- Submit Buttons -->
                <div
                    class="row"
                    *ngIf="!this.invoiceData.data.isRefund; else refundBlock"
                >
                    <div class="col">
                        <div class="d-flex justify-content-center">
                            <p-button
                                (click)="onSubmit()"
                                [disabled]="!isPaymentValid() || submitForm"
                                [loading]="submitForm"
                                label="Save"
                            ></p-button>
                        </div>
                    </div>
                </div>
                <ng-template #refundBlock>
                    <div class="col">
                        <div class="d-flex justify-content-center">
                            <p-button
                                (click)="onMakeRefund()"
                                [loading]="submitForm"
                                [disabled]="submitForm || (hasSiblings ? !isSiblingRefundValid() : !this.receivePmtFrom.valid)"
                                label="Make Refund"
                            ></p-button>
                        </div>
                    </div>
                </ng-template>
            </form>
        </div>
    </div>
</div>
<ng-template #elseBlock>
    <div class="container-fluid">
        <div
            class="card-form"
            style="display: flex; align-items: center; justify-content: center"
        >
            <p-progressSpinner
                [style]="{ width: '45px', height: '37px' }"
                styleClass="custom-spinner"
                strokeWidth="8"
                fill="var(--surface-ground)"
                animationDuration=".9s"
            ></p-progressSpinner>
        </div>
    </div>
</ng-template>
